<div class="page-title-area">
  <div class="d-table">
    <div class="d-table-cell">
      <div class="container">
        <div class="page-title-text">
                    <h2>A PROPOS DE QUALIFPME</h2>
          <ul>
            <li><a routerLink="/">ACCUEIL</a></li>
            <li><i class="icofont-simple-right"></i></li>
                        <li>A PROPOS DE LA QUALIFPME</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Hero Section -->

 <!-- Introduction Section -->
<section class="introduction-section">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6">
        <div class="intro-visual">
          <div class="main-image-container">
            <img src="/assets/img/upload/about/359x522.png" alt="QualifPME Platform" class="main-image img-fluid">
            <div class="image-badge">
              <i class="icofont-certificate"></i>
              <span>Certification Garantie</span>
            </div>
          </div>
          <!-- <div class="secondary-images-container">
            <div class="secondary-image-card">
              <img src="/assets/img/upload/about/245x331.png" alt="Certification Process" class="img-fluid">
              <div class="floating-badge">
                <i class="icofont-award"></i>
                <span>Excellence</span>
              </div>
            </div>
          </div> -->
        </div>
      </div>
      <div class="col-lg-6">
        <div class="intro-content">
          <div class="section-header">
            <div class="badge">Plateforme de Qualification des PME</div>
            <h2 class="section-title">Révolutionner la Qualification des Entreprises</h2>
            <p class="section-subtitle">
              Nous sommes la référence en matière de qualification et de certification des Petites et Moyennes Entreprises. 
              Notre plateforme digitale révolutionnaire accompagne les PME dans leur processus de qualification, 
              en évaluant leurs capacités techniques, financières et organisationnelles selon les standards internationaux.
            </p>
          </div>
          
          <div class="features-grid">
            <div class="feature-item">
              <div class="feature-icon">
                <i class="icofont-check-circled"></i>
              </div>
              <div class="feature-content">
                <h4>Évaluation Rigoureuse</h4>
                <p>Processus d'évaluation complet selon les normes internationales</p>
              </div>
            </div>
            
            <div class="feature-item">
              <div class="feature-icon">
                <i class="icofont-shield-alt"></i>
              </div>
              <div class="feature-content">
                <h4>Certification Reconnue</h4>
                <p>Attestations officielles reconnues par les donneurs d'ordre</p>
              </div>
            </div>
            
            <div class="feature-item">
              <div class="feature-icon">
                <i class="icofont-chart-line"></i>
              </div>
              <div class="feature-content">
                <h4>Croissance Assurée</h4>
                <p>Accès facilité aux marchés publics et privés</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Statistics Section -->
<section class="statistics-section">
  <div class="container">
    <div class="section-header text-center">
      <h2 class="section-title">QualifPME en Chiffres</h2>
      <p class="section-subtitle">Des résultats qui témoignent de notre excellence</p>
    </div>
    
    <div class="statistics-grid">
      <div class="stat-card">
        <div class="stat-icon">
          <i class="icofont-business"></i>
        </div>
        <div class="stat-content">
          <h3 class="stat-number">{{ appSettingService.value.total_supplier }}</h3>
          <p class="stat-label">PME Qualifiées</p>
          <div class="stat-trend positive">
            <i class="icofont-arrow-up"></i>
            <span>+15% ce mois</span>
          </div>
        </div>
      </div>
      
      <div class="stat-card">
        <div class="stat-icon">
          <i class="icofont-users-alt-3"></i>
        </div>
        <div class="stat-content">
          <h3 class="stat-number">{{ appSettingService.value.total_buyer }}</h3>
          <p class="stat-label">Donneurs d'Ordre</p>
          <div class="stat-trend positive">
            <i class="icofont-arrow-up"></i>
            <span>+8% ce mois</span>
          </div>
        </div>
      </div>
      
      <div class="stat-card">
        <div class="stat-icon">
          <i class="icofont-clipboard"></i>
        </div>
        <div class="stat-content">
          <h3 class="stat-number">{{ appSettingService.value.total_request }}</h3>
          <p class="stat-label">Campagnes de Qualification</p>
          <div class="stat-trend positive">
            <i class="icofont-arrow-up"></i>
            <span>+22% ce mois</span>
          </div>
        </div>
      </div>
      
      <div class="stat-card">
        <div class="stat-icon">
          <i class="icofont-handshake-deal"></i>
        </div>
        <div class="stat-content">
          <h3 class="stat-number">{{ appSettingService.value.total_organisme }}</h3>
          <p class="stat-label">Organismes Partenaires</p>
          <div class="stat-trend positive">
            <i class="icofont-arrow-up"></i>
            <span>+5% ce mois</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Mission & Vision Section -->
<section class="mission-section">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6">
        <div class="mission-content">
          <div class="section-header">
            <div class="badge">Notre Mission</div>
            <h2 class="section-title">Élever le Standard des PME</h2>
            <p class="section-subtitle">
              QualifPME s'engage à transformer l'écosystème entrepreneurial en établissant des standards 
              de qualification rigoureux et transparents pour un développement économique durable.
            </p>
          </div>
          
          <div class="mission-points">
            <div class="mission-point">
              <div class="point-icon">
                <i class="icofont-bullseye"></i>
              </div>
              <div class="point-content">
                <h4>Excellence</h4>
                <p>Établir les plus hauts standards de qualification</p>
              </div>
            </div>
            
            <div class="mission-point">
              <div class="point-icon">
                <i class="icofont-eye-alt"></i>
              </div>
              <div class="point-content">
                <h4>Transparence</h4>
                <p>Processus d'évaluation ouverts et équitables</p>
              </div>
            </div>
            
            <div class="mission-point">
              <div class="point-icon">
                <i class="icofont-growth"></i>
              </div>
              <div class="point-content">
                <h4>Croissance</h4>
                <p>Faciliter l'accès aux opportunités de marché</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="col-lg-6">
        <div class="mission-visual">
          <div class="visual-grid">
            <img src="/assets/img/upload/about/342x514.png" alt="Mission QualifPME" class="main-visual">
            <div class="visual-cards">
              <div class="visual-card">
                <img src="/assets/img/upload/about/252x306.png" alt="Processus">
                <div class="card-overlay">
                  <i class="icofont-cog"></i>
                  <span>Processus</span>
                </div>
              </div>
              <div class="visual-card">
                <img src="/assets/img/upload/about/252x213.png" alt="Certification">
                <div class="card-overlay">
                  <i class="icofont-certificate"></i>
                  <span>Certification</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Team Section -->
<section class="team-section">
  <div class="container">
    <div class="section-header text-center">
      <div class="badge">Notre Équipe</div>
      <h2 class="section-title">Experts en Qualification d'Entreprises</h2>
      <p class="section-subtitle">
        Une équipe multidisciplinaire d'experts dédiée à votre succès
      </p>
    </div>
    
    <div class="team-description">
      <div class="description-card">
        <div class="card-icon">
          <i class="icofont-users-alt"></i>
        </div>
        <div class="card-content">
          <h3>Expertise Combinée</h3>
          <p>
            Notre équipe réunit des évaluateurs d'entreprises, des auditeurs certifiés, 
            des spécialistes sectoriels et des consultants en développement économique. 
            Forts de notre connaissance approfondie du marché, nous accompagnons chaque PME 
            dans son parcours de qualification avec rigueur et bienveillance.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Services Section -->
<section class="services-section">
  <div class="container">
    <div class="section-header text-center">
      <h2 class="section-title">Nos Services de Qualification</h2>
      <p class="section-subtitle">Une gamme complète de services pour votre certification</p>
    </div>
    
    <div class="services-grid">
      <div class="service-card">
        <div class="service-header">
          <div class="service-icon">
            <i class="icofont-cogs"></i>
          </div>
          <h3>Services de Qualification</h3>
        </div>
        <div class="service-content">
          <p>
            Découvrez notre gamme complète de services : évaluation des capacités techniques, 
            audit financier, vérification des références, certification des compétences.
          </p>
          <ul class="service-list">
            <li><i class="icofont-check"></i>Évaluation technique approfondie</li>
            <li><i class="icofont-check"></i>Audit financier et comptable</li>
            <li><i class="icofont-check"></i>Vérification des références clients</li>
            <li><i class="icofont-check"></i>Certification des compétences</li>
          </ul>
        </div>
      </div>
      
      <div class="service-card">
        <div class="service-header">
          <div class="service-icon">
            <i class="icofont-handshake"></i>
          </div>
          <h3>Engagements Qualité</h3>
        </div>
        <div class="service-content">
          <p>
            Nous nous engageons à maintenir les plus hauts standards de qualité dans nos processus. 
            Transparence, équité, rigueur et accompagnement personnalisé sont au cœur de notre approche.
          </p>
          <ul class="service-list">
            <li><i class="icofont-check"></i>Processus transparent et équitable</li>
            <li><i class="icofont-check"></i>Délais de traitement respectés</li>
            <li><i class="icofont-check"></i>Accompagnement personnalisé</li>
            <li><i class="icofont-check"></i>Certification reconnue officiellement</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- CTA Section -->
<section class="cta-section">
  <div class="container">
    <div class="cta-content">
      <div class="cta-text">
        <h2>Prêt à Qualifier Votre Entreprise?</h2>
        <p>Rejoignez les centaines de PME qui font déjà confiance à QualifPME</p>
      </div>
      <div class="cta-buttons">
        <button class="cta-btn primary">
          <i class="icofont-certificate"></i>
          Commencer la Qualification
        </button>
        <button class="cta-btn secondary">
          <i class="icofont-info-circle"></i>
          En Savoir Plus
        </button>
      </div>
    </div>
  </div>
</section>
